import Tobii from "@midzer/tobii/dist/tobii.module.js";

const tobii001 = new Tobii({
	selector: ".js-lightbox",
    captions: false,
    nav: "auto"
})